<div class="ad-slot" *ngIf="ads.length">

  <ng-container *ngIf="ads[current] as ad">

    <a
      *ngIf="ad.linkUrl && isInternal(ad.linkUrl)"
      class="ad-link"
      [routerLink]="ad.linkUrl">
      <img [src]="ad.imageUrl" alt="Advertisement" loading="lazy" decoding="async">
    </a>

    <a
      *ngIf="ad.linkUrl && !isInternal(ad.linkUrl)"
      class="ad-link"
      [href]="ad.linkUrl"
      target="_blank"
      rel="noopener noreferrer">
      <img [src]="ad.imageUrl" alt="Advertisement" loading="lazy" decoding="async">
    </a>

    <img
      *ngIf="!ad.linkUrl"
      [src]="ad.imageUrl"
      alt="Advertisement"
      loading="lazy"
      decoding="async">

  </ng-container>

  <div class="dots" *ngIf="ads.length > 1">
    <span
      *ngFor="let a of ads; let i = index"
      [class.on]="i === current"
      (click)="go(i)"></span>
  </div>

</div>
